import { Link } from "react-router-dom";
import { Instagram, Youtube, Music } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8cb5d32c-b1ce-4951-b77e-897f98e6cc9f/artifacts/uyctypm7_41ed1e03-8bc9-42a0-8314-b43b52fec9a9.JPG";

export function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10" role="contentinfo" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" aria-label="Afro Fanthem Home">
              <img src={LOGO_URL} alt="Afro Fanthem Logo" className="h-12 w-auto mb-4" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              The Voice of African Football Fans. United by Passion, Powered by Pride.
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-4">Explore</h4>
            <nav aria-label="Explore links">
              <ul className="space-y-2">
                <li><Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-about">About Us</Link></li>
                <li><Link to="/forum" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-forum">Fan Forum</Link></li>
                <li><Link to="/survey" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-survey">Take the Survey</Link></li>
                <li><Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-contact">Contact</Link></li>
              </ul>
            </nav>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-4">Legal & Data</h4>
            <nav aria-label="Legal links">
              <ul className="space-y-2">
                <li><Link to="/data-policy" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-data-policy">Data Policy</Link></li>
                <li><Link to="/data-storage" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-data-storage">Data Storage</Link></li>
                <li><Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
                <li><Link to="/forum-rules" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-forum-rules">Forum Rules</Link></li>
              </ul>
            </nav>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-4">Follow Us</h4>
            <div className="flex flex-wrap gap-3">
              <a href="https://www.instagram.com/afrofanthem/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 bg-white/5 border border-white/10 flex items-center justify-center hover:border-pink-500/50 hover:bg-pink-500/10 transition-all">
                <Instagram className="w-5 h-5 text-pink-500" />
              </a>
              <a href="https://www.youtube.com/@AfroFanthem" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="w-10 h-10 bg-white/5 border border-white/10 flex items-center justify-center hover:border-red-500/50 hover:bg-red-500/10 transition-all">
                <Youtube className="w-5 h-5 text-red-500" />
              </a>
              <a href="https://open.spotify.com/artist/2p4fVYvsZF323pRXdhUEDC" target="_blank" rel="noopener noreferrer" aria-label="Spotify" className="w-10 h-10 bg-white/5 border border-white/10 flex items-center justify-center hover:border-green-500/50 hover:bg-green-500/10 transition-all">
                <Music className="w-5 h-5 text-green-500" />
              </a>
              <a href="https://www.tiktok.com/@afrofanthem" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="w-10 h-10 bg-white/5 border border-white/10 flex items-center justify-center hover:border-white/50 hover:bg-white/10 transition-all">
                <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/></svg>
              </a>
              <a href="https://x.com/Afrofanthem" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" className="w-10 h-10 bg-white/5 border border-white/10 flex items-center justify-center hover:border-white/50 hover:bg-white/10 transition-all">
                <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
            </div>
            <div className="mt-4 space-y-1">
              <a href="mailto:afrofanthem@afrofanthem.com" className="text-gray-400 hover:text-[#FBBF24] text-sm transition-colors block">afrofanthem@afrofanthem.com</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} Afro Fanthem. All rights reserved.</p>
          <p className="text-gray-600 text-xs">Operated by Southern African Traders Ltd (Company No. 12003857)</p>
        </div>
      </div>
    </footer>
  );
}
